/* eslint-disable react/jsx-filename-extension */
/* eslint-disable import/extensions */
import React from 'react';
import { Route, Routes } from 'react-router-dom';

import SiteLoader from 'parts/SiteLoader';
import SectionScrollReveal from 'parts/SectionScrollReveal';
import ScrollToTop from 'parts/ScrollToTop';
import HomePage from 'pages/HomePage';
import ProjectPage from 'pages/ProjectPage';
import { ProjectDetailPage } from 'pages/ProjectDetailPage';
import TeamPage from 'pages/TeamPage';
import ServicesPage from 'pages/ServicesPage';
import ProcessPage from 'pages/ProcessPage';
import InsightsPage from 'pages/InsightsPage';
import PricingPage from 'pages/PricingPage';
import { DiscussProjectPage } from 'pages/DiscussProjectPage';
import NotFoundPage from 'pages/NotFoundPage';

import './assets/css/styles.css';

function App() {
  return (
    <>
      <SiteLoader />
      <SectionScrollReveal />
      <ScrollToTop />
      <Routes>
        <Route exact path="/" element={<HomePage />} />
        <Route path="/services" element={<ServicesPage />} />
        <Route path="/process" element={<ProcessPage />} />
        <Route path="/work" element={<ProjectPage />} />
        <Route path="/work/:id" element={<ProjectDetailPage />} />
        {/* legacy /project paths */}
        <Route path="/project" element={<ProjectPage />} />
        <Route path="/project/:id" element={<ProjectDetailPage />} />
        <Route path="/team" element={<TeamPage />} />
        <Route path="/insights" element={<InsightsPage />} />
        <Route path="/pricing" element={<PricingPage />} />
        <Route path="/discuss-project" element={<DiscussProjectPage />} />
        <Route path="/contact" element={<DiscussProjectPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </>
  );
}

export default App;
